import * as types from "../mutation-type"
import axios from "axios/index";


export default {
  state: {
    modules: {
      info:[]
    },
  },
  mutations: {
    [types.SET_MODULE](state, payload) {
      state.modules.info = payload.info
    },

  },
  actions: {
    getModule({dispatch, commit}) {

      let url = process.env.VUE_APP_API_URL + "module/all"
      //console.log(url)
      return axios.get(url).then(function(response){

        let data = response.data.data
        //console.log(data)
        commit({
          type: types.SET_MODULE,
          info: data
        })
      }).catch(err => {
        console.log(err)
      })
    },

  }
}
